/**
 * AktionenBar — Admin-gegatete Deaktivieren/Löschen-Buttons in der Auswahl-Leiste
 * (Plan 03-04, ACT-01/02, PROT-05). Die Komponente selbst prueft NICHT die
 * Admin-Rolle — das macht WarnlistePage ueber `isAdmin()` und rendert die Bar nur
 * dann ueberhaupt. Das Backend erzwingt `manage:artikelleichen` zusaetzlich
 * (requirePermission mit Admin-Bypass, PROT-05) — dieses Frontend-Gate ist reiner
 * UX-Komfort, keine Sicherheitsgrenze.
 */
import { Button } from '@libero/core/components/ui/button';

interface AktionenBarProps {
  anzahl: number;
  onDeaktivieren: () => void;
  onLoeschen: () => void;
  disabled?: boolean;
}

export default function AktionenBar({ anzahl, onDeaktivieren, onLoeschen, disabled }: AktionenBarProps) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <Button type="button" variant="outline" onClick={onDeaktivieren} disabled={disabled}>
        {anzahl === 1 ? 'Deaktivieren' : `${anzahl} deaktivieren`}
      </Button>
      <Button
        type="button"
        onClick={onLoeschen}
        disabled={disabled}
        className="bg-red-600 text-white hover:bg-red-700"
      >
        {anzahl === 1 ? 'Endgültig löschen' : `${anzahl} endgültig löschen`}
      </Button>
    </div>
  );
}
